import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import Coupon from './Coupon';
import CheckoutForm from './CheckoutForm';

const Checkout = ({ productCode, productCodeType, stripeApiKey }) => {
    const stripePromise = loadStripe(stripeApiKey);

    const renderCouponForm = () => {
        if (productCodeType == 'product') {
            return <Coupon />;
        }
    }

    return (
        <Elements stripe={stripePromise}>
            {renderCouponForm()}
            <CheckoutForm productCode={productCode} productCodeType={productCodeType} />
        </Elements>
    );
}

export default Checkout;
